import { PuzzleSwapApi } from '@/api/puzzle-swapapi';


export const usePuzzleSwapApi = () => {
    return new PuzzleSwapApi('https://swapapi.puzzleswap.org');
}